export default __webpack_public_path__ + "static/media/Deep-Drain-.e69806a1.jpg";